import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";

export const HideShowRedirectionUrlConfig = [
    {
        id: "redirectionUrl",
        label: "Redirection Url",
        Field_Name: "Redirection Url",
        fieldType: FormFieldTypes.INPUT,
        dataField: "redirectionUrl",
        fieldSetting: {
            placeholder: "Enter Redirection URL",
            allowSpace: true,
            textareaRows: 4,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-6 col-md-6",
        },
    },
]
